import React, { useState, useMemo, useEffect } from "react";
import {
  Drawer,
  Button,
  Typography,
  Collapse,
  message,
  Tabs,
  Spin,
  Tooltip,
  Grid,
  Layout,
  Table,
  Checkbox,
} from "antd";
import {
  MinusOutlined,
  PlusOutlined,
  StarOutlined,
  DeleteOutlined,
  CloseOutlined,
  InboxOutlined,
  UndoOutlined,
  HistoryOutlined,
  ShoppingCartOutlined,
  BookOutlined,
} from "@ant-design/icons";
import { axiosInstance } from "../utils/axiosInterceptor";
import { useSelector } from "react-redux";
import OrderConfirmationModal from "../components/orderConfirmationModal/OrderConfirmationModal";
import { Bookmark } from "lucide-react";

const { Text } = Typography;
const { Panel } = Collapse;
const { Content } = Layout;

const CartDrawer = ({
  visible,
  onClose,
  selectedProducts,
  setSelectedProducts,
  getCartData,
  getCatalogueDetails,
  pageSize,
  currentPage,
  getFavourite,
  faviouriteList,
  cartLoading,
  setCartloading,
  accountNo,
  supplierId,
  userId,
}) => {
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const [favorites, setFavorites] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const userAuth = useSelector((state) => state.userAuth.decodedToken?.user);
  const [activeTab, setActiveTab] = useState("cart");
  const [isPopUpOpen, setIsPopUpOpen] = useState(false);
  const [gcrImpTableData, setGcrImpTableData] = useState({
    current: {},
    change: {},
  });
  const [tblLoading, setTblLoading] = useState(false);
  const brandDelta = selectedProducts
    ?.filter((item) => item?.brand_type === "brand")
    .reduce(
      (total, item) =>
        total + Number(item?.quantity) * Number(item?.unit_price),
      0,
    );

  const genericDelta = selectedProducts
    ?.filter((item) => item?.brand_type === "generic")
    .reduce(
      (total, item) =>
        total + Number(item?.quantity) * Number(item?.unit_price),
      0,
    );

  const { TabPane } = Tabs;

  const groupedProducts = useMemo(() => {
    return selectedProducts.reduce((acc, product) => {
      const supplier = product?.supplier_name || "AAFA";
      if (!acc[supplier]) acc[supplier] = [];
      acc[supplier].push(product);
      return acc;
    }, {});
  }, [selectedProducts]);

  const SavedProducts = useMemo(() => {
    return faviouriteList?.reduce((acc, product) => {
      const supplier = product?.supplier_name || "AAFA";
      if (!acc[supplier]) acc[supplier] = [];
      acc[supplier].push(product);
      return acc;
    }, {});
  }, [faviouriteList]);

  const totalCost = selectedProducts?.reduce(
    (sum, p) => sum + p.unit_price * p.quantity,
    0,
  );

  const totalSavings = 0;

  const getGCRImpData = async () => {
    setTblLoading(true);
    const payload = {
      accounts: accountNo,
      year: String(new Date().getFullYear()),
      quarter: String(Math.ceil((new Date().getMonth() + 1) / 3)),
      // targetPct: "",
      genericDelta: genericDelta?.toFixed(2),
      brandDelta: brandDelta?.toFixed(2),
    };
    try {
      const response = await axiosInstance.post(
        "api/v2/users/gcr/quarterly-calculator",
        payload,
      );
      setGcrImpTableData(response?.data);
    } catch (error) {
      console.log(error, "Erroror");
    } finally {
      setTblLoading(false);
    }
  };

  const handleQuantityChange = async (productCode, newQty, maxQty, partyId) => {
    if (newQty < 2) return;

    if (newQty > maxQty) return;

    setCartloading(true);
    const payload = {
      // userId: userAuth?.id,
      product_code: productCode,
      quantity: newQty,
      acct_id: accountNo,
      party_id: partyId,
    };
    try {
      const response = await axiosInstance.post(
        "api/marketplace/cart/update",
        payload,
        //  {
        //     headers : {
        //       "x-api-key" : "01486e2946f424268dbcf835b976130f09485eddfbb9fbeaa9b9607bc737d0d4"
        //     }
        //   },
      );
      message.success(response?.data?.message);
      setSelectedProducts((prev) =>
        prev.map((p) =>
          p.product_code === productCode ? { ...p, quantity: newQty } : p,
        ),
      );
    } catch (error) {
      console.log(error, "error");
      message.error("Something Went Wrong");
    } finally {
      setCartloading(false);
    }
  };

  useEffect(() => {
    getFavourite();
    getCartData();
    setActiveTab("cart");
  }, [visible]);

  useEffect(() => {
    getGCRImpData();
  }, [genericDelta, brandDelta]);

  useEffect(() => {
    if (visible) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }

    return () => {
      document.body.style.overflow = "";
    };
  }, [visible]);

  const handleRemoveFromCart = async (product) => {
    setCartloading(true);
    const payload = {
      // userId: userAuth?.id,
      acct_id: accountNo,
      party_id: product?.party_id,
      product_code: product?.product_code,
    };
    try {
      const response = await axiosInstance.post(
        "api/marketplace/cart/remove",
        payload,
        //  {
        //     headers : {
        //       "x-api-key" : "01486e2946f424268dbcf835b976130f09485eddfbb9fbeaa9b9607bc737d0d4"
        //     }
        //   },
      );
      message.success("Item Removed SuccessFully")
      getCartData();
    } catch (error) {
      console.log(error, "Errrorr");
    } finally {
    }
  };

  const toggleFavorite = (productCode) => {
    setFavorites((prev) => ({
      ...prev,
      [productCode]: !prev[productCode],
    }));
  };

  const CustomPanelHeader = ({ supplier, products }) => (
    <div className="flex items-center justify-between w-full">
      <div className="flex items-center gap-2">
        {/* <span className="text-blue-600">⊕</span> */}
        <Text strong>{supplier}</Text>
      </div>
      <Text type="secondary" className="text-sm">
        {products?.length} items
      </Text>
    </div>
  );
  const CheckOut = async () => {
    if (!accountNo || !userId) {
      return;
    }
    setIsLoading(true);
    const payload = {
      // userId: userAuth?.id,
      // customer_name: userAuth?.first_name,
      // customer_id:accountNo,
      // party_id:supplierId,
      // user_id:userId
      acct_id: accountNo,
    };
    try {
      const response = await axiosInstance.post(
        "api/marketplace/cart/checkout",
        payload,
        //  {
        //     headers : {
        //       "x-api-key" : "01486e2946f424268dbcf835b976130f09485eddfbb9fbeaa9b9607bc737d0d4"
        //     }
        //   },
      );
      // console.log(response,"Reposneee")
      onClose();
      message.success(`${response?.data?.message} `);
      getCatalogueDetails(currentPage, pageSize);
    } catch (error) {
      console.log(error, "Error");
      message.error(error?.response?.data?.message);
    } finally {
      setIsLoading(false);
    }
  };

  const addToFavourite = async (code) => {
    const payload = {
      userId: userAuth?.id,
      product_code: code,
      acct_id: accountNo,
    };
    setCartloading(true);
    try {
      const response = await axiosInstance.post(
        "api/marketplace/cart/save-for-later/add",
        payload,
        //  {
        //     headers : {
        //       "x-api-key" : "01486e2946f424268dbcf835b976130f09485eddfbb9fbeaa9b9607bc737d0d4"
        //     }
        //   },
      );
      message.success(response?.data?.message)
      await getCartData();
      await getFavourite();
    } catch (error) {
      console.log(error, "Error");
    } finally {
      setCartloading(false);
    }
  };
  const NoProductsFound = () => {
    return (
      <div className="flex flex-col items-center justify-center py-16 text-center">
        <div className="w-20 h-20 rounded-full bg-gray-100 flex items-center justify-center mb-4">
          <InboxOutlined className="text-4xl text-gray-400" />
        </div>

        <h3 className="text-lg font-semibold text-gray-700">
          No Products Found
        </h3>

        <p className="mt-2 text-sm text-gray-500 max-w-xs">
          There are no products to display at the moment.
        </p>
      </div>
    );
  };

  const movetoCart = async (code) => {
    if (!accountNo || !userId) {
      return;
    }
    setCartloading(true);
    const payload = {
      // userId: userAuth?.id,
      product_code: code,
      acct_id: accountNo,
      // party_id:supplierId,
      userId: userId,
    };
    try {
      const response = await axiosInstance.post(
        "api/marketplace/cart/save-for-later/move-to-cart",
        payload,
        //  {
        //     headers : {
        //       "x-api-key" : "01486e2946f424268dbcf835b976130f09485eddfbb9fbeaa9b9607bc737d0d4"
        //     }
        //   },
      );
      message.success(response?.data?.message)
      await getFavourite();
      await getCartData();
    } catch (error) {
      console.log(error, "Error");
    } finally {
      setCartloading(false);
    }
  };
  const handleRemoveFromFavourite = async (code) => {
    setCartloading(true);
    const payload = {
      userId: userAuth?.id,
      product_code: code,
      acct_id: accountNo,
    };
    try {
      const response = await axiosInstance.post(
        "api/marketplace/cart/save-for-later/remove",
        payload,
        //  {
        //     headers : {
        //       "x-api-key" : "01486e2946f424268dbcf835b976130f09485eddfbb9fbeaa9b9607bc737d0d4"
        //     }
        //   },
      );
      message.success(response?.data?.message)
      await getFavourite();
    } catch (error) {
      console.log(error, "Error");
    } finally {
      setCartloading(false);
    }
  };

  const columns = [
    {
      title: "Product",
      dataIndex: "product_name",
      key: "product_name",
      render: (val) =>
        val ? (
          <div className="flex items-center gap-2">
            <span>{val}</span>
          </div>
        ) : (
          <span>-</span>
        ),
      sorter: false,
    },
    {
      title: "Supplier",
      dataIndex: "supplier_name",
      key: "supplier_name",
      render: (val) =>
        val ? (
          <div className="flex items-center gap-2">
            <span>{val}</span>
          </div>
        ) : (
          <span>-</span>
        ),
      sorter: false,
    },
    {
      title: "Unit Price ($)",
      dataIndex: "unit_price",
      key: "unit_price",
      align: "right",
      render: (val) =>
        val ? (
          <div className="">
            <span>$ {val?.toFixed(2)}</span>
          </div>
        ) : (
          <span>-</span>
        ),
      sorter: false,
    },
    {
      title: "Do Not Sub.",
      dataIndex: "do_not_sub",
      key: "do_not_sub",
      render: (doNotSub, record) => (
        <Checkbox
          checked={!!doNotSub}
          //      onChange={(e) =>
          //    updateDoNotSubChange(e.target.checked, record)
          //  }
          className="rounded-sm"
        />
        // <span>-</span>
      ),
    },
    {
      title: "Quantity",
      dataIndex: "",
      key: "",
      render: (val, product) => {
        const qty = Number(product?.quantity ?? 0);
        const availableQty = Number(product?.available_quantity ?? 0);
        const isDisabled = qty >= availableQty;
        return (
          <div className="flex items-center justify-between">
            <div className="flex items-center border border-[#d0d7e2] rounded-[6px] overflow-hidden bg-white">
              <div
                onClick={() =>
                  handleQuantityChange(
                    product?.product_code,
                    product?.quantity - 1,
                    product?.available_quantity,
                    product?.party_id,
                  )
                }
                className={`w-[36px] h-[32px] flex items-center justify-center select-none border-r border-[#d0d7e2] ${
                  Number(product?.quantity) <= 1
                    ? "cursor-not-allowed text-gray-400 bg-gray-100"
                    : "cursor-pointer text-[#4a4a4a]"
                }`}
              >
                −
              </div>
              <div className="w-[44px] h-[32px] flex items-center justify-center border-r border-[#d0d7e2] text-[#4a4a4a] text-sm">
                {product?.quantity}
              </div>

              <div
                onClick={() =>
                  handleQuantityChange(
                    product?.product_code,
                    product?.quantity + 1,
                    product?.available_quantity,
                    product?.party_id,
                  )
                }
                className={`w-[36px] h-[32px] flex items-center justify-center select-none text-[#4a4a4a]
                     ${
                       isDisabled
                         ? "cursor-not-allowed text-gray-400 bg-gray-100"
                         : "cursor-pointer text-[#4a4a4a]"
                     }`}
              >
                +
              </div>
            </div>
          </div>
        );
      },
      sorter: false,
    },
    {
      title: "Total Price ($)",
      dataIndex: "",
      key: "",
      align: "right",
      render: (_, product) => (
        <>
          ${" "}
          {Number(product?.unit_price * product?.quantity).toLocaleString(
            undefined,
            {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            },
          )}
        </>
      ),
      sorter: false,
    },
    {
      title: "Actions",
      dataIndex: "",
      key: "",
      render: (val, product) => (
        <>
          <div>
            <Tooltip title={"Move to Saved Products"}>
              <Button
                type="text"
                icon={
                  <StarOutlined
                    className={
                      favorites[product?.product_code]
                        ? "text-yellow-400"
                        : "text-gray-400"
                    }
                  />
                }
                size="small"
                // onClick={() => toggleFavorite(product.product_code)}
                onClick={() => addToFavourite(product?.product_code)}
              />
            </Tooltip>
            <Tooltip title={"Remove From Cart"}>
              <Button
                type="text"
                icon={<DeleteOutlined className="text-red-600" />}
                size="small"
                onClick={() => handleRemoveFromCart(product)}
              />
            </Tooltip>
          </div>
        </>
      ),
      sorter: false,
    },
  ];

  const savedItemscolumns = [
    {
      title: "Product",
      dataIndex: "product_name",
      key: "product_name",
      render: (val) =>
        val ? (
          <div className="flex items-center gap-2">
            <span>{val}</span>
          </div>
        ) : (
          <span>-</span>
        ),
      sorter: false,
    },
    {
      title: "Supplier",
      dataIndex: "supplier_name",
      key: "supplier_name",
      render: (val) =>
        val ? (
          <div className="flex items-center gap-2">
            <span>{val}</span>
          </div>
        ) : (
          <span>-</span>
        ),
      sorter: false,
    },
    {
      title: "Unit Price ($)",
      dataIndex: "unit_price",
      key: "unit_price",
      align: "right",
      render: (val) =>
        val ? (
          <div>
            <span>$ {val?.toFixed(2)}</span>
          </div>
        ) : (
          <span>-</span>
        ),
      sorter: false,
    },
    {
      title: "Quantity",
      dataIndex: "",
      key: "",
      render: (val, product) => {
        const qty = Number(product?.quantity ?? 0);
        const availableQty = Number(product?.available_quantity ?? 0);
        const isDisabled = qty >= availableQty;
        return (
          <div className="w-[44px] h-[32px] flex items-center justify-center border-r border-[#d0d7e2] text-[#4a4a4a] text-sm">
            {product?.quantity}
          </div>
        );
      },
      sorter: false,
    },
    {
      title: "Total Price ($)",
      dataIndex: "",
      key: "",
      align: "right",
      render: (_, product) => (
        <>
          ${" "}
          {Number(product?.unit_price * product?.quantity).toLocaleString(
            undefined,
            {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            },
          )}
        </>
      ),
      sorter: false,
    },
    {
      title: "Actions",
      dataIndex: "",
      key: "",
      render: (val, product) => (
        <>
          <div>
            <Tooltip title={"Move to Cart"}>
              <Button
                type="text"
                icon={<UndoOutlined className="text-gray-500" />}
                size="small"
                onClick={() => movetoCart(product.product_code)}
              />
            </Tooltip>
            <Tooltip title={"Remove from Save Products"}>
              <Button
                type="text"
                icon={<DeleteOutlined className="text-red-600" />}
                size="small"
                onClick={() => handleRemoveFromFavourite(product.product_code)}
              />
            </Tooltip>
          </div>
        </>
      ),
      sorter: false,
    },
  ];

  const formatCurrency = (value) => {
    if (value === null || value === undefined || value === "") {
      return "$ 0.00";
    }
    const number = typeof value === "number" ? value : parseFloat(value);
    return `$ ${Math.abs(number).toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`;
  };

  const formatPercent = (value) => {
    if (value === null || value === undefined || value === "") {
      return "0 %";
    }
    return `${Math.abs(value)}%`;
  };

  const getColor = (val) => (parseFloat(val) < 0 ? "red" : "inherit");



  const descriptionLabels = [
  { key: "totalRx", label: "Total RX Spend", type: "currency" },
  { key: "genericRx", label: "Generic RX Spend", type: "currency" },
  { key: "brandRx", label: "Brand RX Spend", type: "currency" },
  { key: "adjTotal", label: "Adjusted Total", type: "currency" },
  { key: "gcrPct", label: "GCR %", type: "percent" },
  { key: "cogsPct", label: "COGs %", type: "percent" },
  { key: "cogsImpact", label: "COGs Impact", type: "currency" },
];

const formatValue = (value, type) => {
  if (value === null || value === undefined) {
    return "-";
  }

  if (type === "percent") {
    return `${Number(value).toFixed(2)}%`;
  }

  return formatCurrency(value);
};

const getChangeColor = (value) => {
  return getColor(value);
};
 
  return (
    <>
      <Drawer
        title={
          <div className="flex items-center justify-between p-2 border-none">
            <span className="text-[18px] font-bold text-[#0b1c4d]">
              Quick Cart
            </span>
            <div
              onClick={onClose}
              className="w-[30px] h-[30px] flex items-center justify-center rounded-lg bg-[#eef2ff] cursor-pointer hover:bg-[#e0e7ff]"
            >
              <CloseOutlined className="text-[#0b1c4d] text-[18px]" />
            </div>
          </div>
        }
        placement="right"
        onClose={onClose}
        closable={false}
        open={visible}
        width={"100%"}
        bodyStyle={{ padding: 0 }}
    
      >
        <div className="flex flex-col overflow-y-auto">
          <div className="p-4 sm:px-6 ">
            <div className="max-w-[1400px] mx-0">
              <div className="bg-white rounded-xl shadow-sm p-2 w-fit">
                <Tabs
                  activeKey={activeTab}
                  onChange={setActiveTab}
                  className="custom-tabs-new"
                  size="large"
                  items={[
                    {
                      key: "cart",
                      label: (
                        <span className="flex items-center gap-2 px-4 py-2 rounded-lg">
                          <ShoppingCartOutlined />
                          <span className="hidden sm:inline">Cart</span>
                        </span>
                      ),
                    },
                    {
                      key: "saved",
                      label: (
                        <span className="flex items-center gap-2 px-4 py-2 rounded-lg">
                          <Bookmark />
                          <span className="hidden sm:inline">Saved Items</span>
                        </span>
                      ),
                    },
                  ]}
                />
              </div>
            </div>
          </div>          
          <div className="flex-1">
            {activeTab === "cart" ? (
              selectedProducts?.length > 0 ? (
                <div className="relative">
                  <div
                    className={`${
                      cartLoading
                        ? "pointer-events-none blur-sm opacity-60"
                        : ""
                    }`}
                  >
                    {cartLoading && (
                      <div className="absolute inset-0 flex items-center justify-center z-50">
                        <Spin
                          size="large"
                          styles={{
                            indicator: {
                              color: "#722ed1",
                            },
                          }}
                        />
                      </div>
                    )}
                    <div className="flex flex-col mt-4 ml-2 mr-2">
                      <Collapse
                        defaultActiveKey={Object.keys(groupedProducts)}
                        ghost
                        expandIconPosition="end"
                      >
                        {Object.entries(groupedProducts).map(
                          ([supplier, products]) => (
                            <Panel
                              key={supplier}
                              className="custom-collapse-panel"
                              header={
                                <CustomPanelHeader
                                  supplier={supplier}
                                  products={products}
                                />
                              }
                            >
                              <div className="mt-[-30px] max-h-[420px] overflow-y-auto">
                                <Table
                                  columns={columns}
                                  dataSource={products}
                                  rowKey="id"
                                  scroll={{ x: "max-content" }}
                                  loading={cartLoading}
                                  className="custom-table user-tbl"
                                  pagination={false}
                                />
                              </div>
                            </Panel>
                          ),
                        )}
                      </Collapse>
                    </div>
                  </div>
                </div>
              ) : (
                <NoProductsFound />
              )
            ) : faviouriteList?.length > 0 ? (
              <div className="relative">
                <div
                  className={`${
                    cartLoading ? "pointer-events-none blur-sm opacity-60" : ""
                  }`}
                >
                  {cartLoading && (
                    <div className="absolute inset-0 flex items-center justify-center z-50">
                      <Spin
                        size="large"
                        styles={{
                          indicator: {
                            color: "#722ed1",
                          },
                        }}
                      />
                    </div>
                  )}

                  <div className="flex flex-col mt-4 mb-4 ml-2 mr-2">
                    <Collapse
                      defaultActiveKey={Object.keys(SavedProducts)}
                      ghost
                      expandIconPosition="end"
                    >
                      {Object.entries(SavedProducts).map(
                        ([supplier, products]) => (
                          <Panel
                            key={supplier}
                            className="custom-collapse-panel"
                            header={
                              <CustomPanelHeader
                                supplier={supplier}
                                products={products}
                              />
                            }
                          >
                            <div className="mt-[-30px] max-h-[600px] overflow-y-auto ">
                              <Table
                                columns={savedItemscolumns}
                                dataSource={products}
                                rowKey="id"
                                scroll={{ x: "max-content" }}
                                loading={cartLoading}
                                className="custom-table user-tbl"
                                pagination={false}
                              />
                            </div>
                          </Panel>
                        ),
                      )}
                    </Collapse>
                  </div>
                </div>
              </div>
            ) : (
              <NoProductsFound />
            )}
          </div>
          {/* </div> */}
        </div>
        {
          activeTab === "cart" ? (
            selectedProducts?.length > 0 ? (
              <div className="relative">
                <div
                  className={`${
                    cartLoading ? "pointer-events-none blur-sm opacity-60" : ""
                  }`}
                >
                  
            {/* <div className="flex justify-between items-center">
              <div className="flex flex-col">
              <span className="text-[20px] font-semibold text-black mx-6 mt-4">
                GCR & COGS Impact
              </span>
             
              <div className="w-full overflow-x-auto">
  <div className="min-w-[900px] overflow-hidden rounded-lg border border-[#D9E2EC]">

    <div
      className="
        grid
        grid-cols-[110px_repeat(7,minmax(130px,1fr))]
        bg-[#DCE9F8]
        text-[12px]
        font-medium
        text-[#374151]
      "
    >
      <div className="px-3 py-2">
        Description
      </div>

      {descriptionLabels.map((item) => (
        <div
          key={item.key}
          className="px-3 py-2 text-right"
        >
          {item.label}
        </div>
      ))}
    </div>

    <div
      className="
        grid
        grid-cols-[110px_repeat(7,minmax(130px,1fr))]
        border-t
        border-[#D9E2EC]
        bg-[#EFF5FC]
        text-[12px]
        text-[#374151]
      "
    >
      <div className="px-3 py-3 font-medium">
        Current
      </div>

      {descriptionLabels.map((item) => (
        <div
          key={item.key}
          className="px-3 py-3 text-right"
        >
          {formatValue(
            gcrImpTableData?.current?.[item.key],
            item.type
          )}
        </div>
      ))}
    </div>

    <div
      className="
        grid
        grid-cols-[110px_repeat(7,minmax(130px,1fr))]
        border-t
        border-[#D9E2EC]
        bg-[#EFF5FC]
        text-[12px]
        text-[#374151]
      "
    >
      <div className="px-3 py-3 font-medium">
        Change
      </div>

      {descriptionLabels.map((item) => {
        const value = gcrImpTableData?.change?.[item.key];

        return (
          <div
            key={item.key}
            className="px-3 py-3 text-right"
            style={{
              color: getChangeColor(value),
            }}
          >
            {formatValue(value, item.type)}
          </div>
        );
      })}
    </div>

  </div>
</div>
              </div>
                  <div className="flex flex-col">
                  <div className="px-4 py-3 bg-white border-t border-[#e5e7eb]">
                    <div className="flex items-center justify-center gap-10">
                      <div className="flex flex-col flex-end">
                        <Text className="text-[12px] text-[#6B7280]">
                          Total Items
                        </Text>
                        <Text
                          strong
                          className="flex text-[16px] text-[#111827] justify-center"
                        >
                          {selectedProducts?.length ?? 0}
                        </Text>
                      </div>
                      <div className="text-[25px]  text-gray-300">|</div>

                      <div className="flex flex-col items-end">
                        <Text className="text-[12px] text-[#6B7280]">
                          Total Cost
                        </Text>
                        <Text
                          strong
                          className="text-[20px] font-bold text-[#222]"
                        >
                          ${" "}
                          {Number(totalCost || 0).toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}
                        </Text>
                      </div>
                    </div>
                  </div>
                  <div className="flex justify-center">
                    <Button
                      // type="primary"
                      // block
                      // style={{
                      //   backgroundColor: "#4F46E5",
                      //   height: "40px",
                      //   color:"#fff"
                      // }}
                      className="!bg-[#001997] hover:!bg-[#061561] text-white border-none hover:!text-white disabled:!bg-[#001997] disabled:!text-white w-[200px]"
                      disabled={selectedProducts?.length === 0}
                      loading={isLoading}
                      // onClick={() => CheckOut()}
                      onClick={() => {
                        setIsPopUpOpen(true);
                      }}
                    >
                      Continue Purchasing
                    </Button>
                  </div>
                  </div>
                  </div> */}
                  <div className="w-full flex flex-col lg:flex-row gap-4 px-4 py-4">

  {/* GCR & COGS Impact */}
  <div className="w-full lg:flex-1 rounded-xl border border-[#D9E2EC] bg-white shadow-sm overflow-hidden">

    {/* Card Header */}
    <div className="px-5 py-3 border-b border-[#E5E7EB] bg-[#F8FAFC]">
      <span className="text-[18px] font-semibold text-[#111827]">
        GCR & COGS Impact
      </span>
    </div>

    <div className="w-full overflow-x-auto px-4 py-4">
      <div className="min-w-[780px] overflow-hidden rounded-lg border border-[#D9E2EC]">

        {/* Header */}
        <div
          className="
            grid
            grid-cols-[100px_repeat(7,minmax(105px,1fr))]
            bg-[#DCE9F8]
            text-[12px]
            font-semibold
            text-[#374151]
          "
        >
          <div className="px-3 py-2">
            Description
          </div>

          {descriptionLabels.map((item) => (
            <div
              key={item.key}
              className="px-3 py-2 text-right whitespace-nowrap"
            >
              {item.label}
            </div>
          ))}
        </div>

        {/* Current */}
        <div
          className="
            grid
            grid-cols-[100px_repeat(7,minmax(105px,1fr))]
            border-t
            border-[#D9E2EC]
            bg-[#F4F8FD]
            text-[12px]
            text-[#374151]
          "
        >
          <div className="px-3 py-3 font-medium text-[#111827]">
            Current
          </div>

          {descriptionLabels.map((item) => (
            <div
              key={item.key}
              className="px-3 py-3 text-right whitespace-nowrap"
            >
              {formatValue(
                gcrImpTableData?.current?.[item.key],
                item.type
              )}
            </div>
          ))}
        </div>

        {/* Change */}
        <div
          className="
            grid
            grid-cols-[100px_repeat(7,minmax(105px,1fr))]
            border-t
            border-[#D9E2EC]
            bg-[#F4F8FD]
            text-[12px]
            text-[#374151]
          "
        >
          <div className="px-3 py-3 font-medium text-[#111827]">
            Change
          </div>

          {descriptionLabels.map((item) => {
            const value = gcrImpTableData?.change?.[item.key];

            return (
              <div
                key={item.key}
                className="px-3 py-3 text-right whitespace-nowrap font-medium"
                style={{
                  color: getChangeColor(value),
                }}
              >
                {formatValue(value, item.type)}
              </div>
            );
          })}
        </div>

      </div>
    </div>
  </div>


  {/* Purchase Summary */}
  <div
    className="
      w-full
      lg:w-[400px]
      flex
      flex-col
      justify-between
      rounded-xl
      border
      border-[#C7D2FE]
      bg-gradient-to-b
      from-[#F5F7FF]
      to-[#FFFFFF]
      shadow-md
      p-5
    "
  >

    {/* Summary Header */}
    <div>
      <div className="flex items-center gap-2 mb-5">
        <div className="w-2 h-6 rounded-full bg-[#001997]" />

        <div className="text-[18px] font-semibold text-[#111827]">
          Purchase Summary
        </div>
      </div>


      {/* Summary Values */}
      <div className="grid grid-cols-2 gap-3">

        {/* Total Items */}
        <div
          className="
            rounded-lg
            border
            border-[#E0E7FF]
            bg-white
            px-4
            py-3
            shadow-sm
          "
        >
          <div className="text-[11px] font-medium text-[#6B7280]">
            Total Items
          </div>

          <div className="text-[20px] font-bold text-[#111827] mt-1">
            {selectedProducts?.length ?? 0}
          </div>
        </div>


        {/* Total Cost */}
        <div
          className="
            rounded-lg
            border
            border-[#E0E7FF]
            bg-white
            px-4
            py-3
            shadow-sm
          "
        >
          <div className="text-[11px] font-medium text-[#6B7280]">
            Total Cost
          </div>

          <div className="text-[24px] font-bold text-[#001997] mt-1 whitespace-nowrap">
            $
            {Number(totalCost || 0).toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}
          </div>
        </div>

      </div>
    </div>


    {/* Continue Button */}
    <div className="mt-6 pt-4 border-t border-[#E5E7EB]">

      <Button
        className="
          !bg-[#001997]
          hover:!bg-[#061561]
          !text-white
          hover:!text-white
          border-none
          disabled:!bg-[#9CA3AF]
          disabled:!text-white
          w-full
          h-[42px]
          rounded-lg
          font-medium
          shadow-sm
        "
        disabled={selectedProducts?.length === 0}
        loading={isLoading}
        onClick={() => {
          setIsPopUpOpen(true);
        }}
      >
        Continue Purchasing
      </Button>

    </div>
  </div>

</div>
                </div>
              </div>
            ) : null
          ) : null
        }
      </Drawer>
      <OrderConfirmationModal
        open={isPopUpOpen}
        onCancel={() => setIsPopUpOpen(false)}
        onConfirm={() => {
          setIsPopUpOpen(false);
          CheckOut();
        }}
        loading={isLoading}
        totalItems={selectedProducts?.length}
        totalPrice={selectedProducts?.reduce(
          (sum, p) => sum + p.unit_price * p.quantity,
          0,
        )}
      />
      <style>
        {`
         .custom-collapse-panel > .ant-collapse-header {
          background: #f3f4f6 !important;
          border-radius: 8px;
          margin-bottom:8px;
        }
        `}
      </style>
    </>
  );
};

export default CartDrawer;

// <div className="relative">
//   <div
//     className={`${
//       cartLoading
//         ? "pointer-events-none blur-sm opacity-60"
//         : ""
//     }`}
//   >
//     {cartLoading && (
//       <div className="absolute inset-0 flex items-center justify-center z-50">
//         <Spin
//           size="large"
//           styles={{
//             indicator: {
//               color: "#722ed1",
//             },
//           }}
//         />
//       </div>
//     )}

//     <div className="flex flex-col mt-4 ml-2 mr-2">
//       <Collapse
//         defaultActiveKey={Object.keys(groupedProducts)}
//         ghost
//         expandIconPosition="end"
//       >
//         {Object.entries(groupedProducts).map(
//           ([supplier, products]) => (
//             <Panel
//               key={supplier}
//               className="custom-collapse-panel"
//               header={
//                 <CustomPanelHeader
//                   supplier={supplier}
//                   products={products}
//                 />
//               }
//             >
//               <Table
//               columns={columns}
//               dataSource={products}
//               rowKey="id"
//               scroll={{ x: "max-content" }}
//               loading={cartLoading}
//               className="custom-table user-tbl"
//               pagination={false}
//             />
//               {products?.map((product) => {
//                 const qty = Number(product?.quantity ?? 0);
//                 const availableQty = Number(
//                   product?.available_quantity ?? 0,
//                 );
//                 const isDisabled = qty >= availableQty;
//                 return (
//                   <div
//                     key={product.product_code}
//                     className="mb-6 px-4"
//                   >
//                     <div className="flex justify-between items-center">
//                       <div>
//                         <Text
//                           className="block mb-1 text-[#222]"
//                           style={{
//                             fontSize: 14,
//                             fontWeight: "500",
//                           }}
//                         >
//                           {product?.product_name}
//                         </Text>
//                       </div>
//                       <div>
//                         <Tooltip title={"Move to Saved Products"}>
//                           <Button
//                             type="text"
//                             icon={
//                               <StarOutlined
//                                 className={
//                                   favorites[
//                                     product?.product_code
//                                   ]
//                                     ? "text-yellow-400"
//                                     : "text-gray-400"
//                                 }
//                               />
//                             }
//                             size="small"
//                             // onClick={() => toggleFavorite(product.product_code)}
//                             onClick={() =>
//                               addToFavourite(
//                                 product?.product_code,
//                               )
//                             }
//                           />
//                         </Tooltip>
//                         <Tooltip title={"Remove From Cart"}>
//                           <Button
//                             type="text"
//                             icon={
//                               <DeleteOutlined className="text-red-600" />
//                             }
//                             size="small"
//                             onClick={() =>
//                               handleRemoveFromCart(
//                                 product
//                               )
//                             }
//                           />
//                         </Tooltip>
//                       </div>
//                     </div>
//                     <div className="flex items-center justify-between">

//                       <div className="flex items-center border border-[#d0d7e2] rounded-[6px] overflow-hidden bg-white">
//                         <div
//                           onClick={() =>
//                             handleQuantityChange(
//                               product?.product_code,
//                               product?.quantity - 1,
//                               product?.available_quantity,
//                               product?.party_id
//                             )
//                           }
//                           className={`w-[36px] h-[32px] flex items-center justify-center select-none border-r border-[#d0d7e2] ${
//                             Number(product?.quantity) <= 10
//                               ? "cursor-not-allowed text-gray-400 bg-gray-100"
//                               : "cursor-pointer text-[#4a4a4a]"
//                           }`}
//                         >
//                           −
//                         </div>

//                         <div className="w-[44px] h-[32px] flex items-center justify-center border-r border-[#d0d7e2] text-[#4a4a4a] text-sm">
//                           {product?.quantity}
//                         </div>

//                         <div
//                           onClick={() =>
//                             handleQuantityChange(
//                               product?.product_code,
//                               product?.quantity + 1,
//                               product?.available_quantity,
//                               product?.party_id
//                             )
//                           }
//                           className={`w-[36px] h-[32px] flex items-center justify-center select-none text-[#4a4a4a]
//     ${
//       isDisabled
//         ? "cursor-not-allowed text-gray-400 bg-gray-100"
//         : "cursor-pointer text-[#4a4a4a]"
//     }`}
//                         >
//                           +
//                         </div>
//                       </div>

//                       <div className="flex items-center gap-3">
//                         <Text strong>
//                           ${" "}
//                           {Number(
//                             product?.unit_price *
//                               product?.quantity,
//                           ).toLocaleString(undefined, {
//                             minimumFractionDigits: 2,
//                             maximumFractionDigits: 2,
//                           })}
//                         </Text>
//                       </div>
//                     </div>
//                   </div>
//                 );
//               })}
//             </Panel>
//           ),
//         )}
//       </Collapse>
//     </div>
//   </div>
// </div>

// {
//   /* <div className="shrink-0 px-2 bg-white z-10">
//             <Tabs
//               activeKey={activeTab}
//               onChange={(key) => setActiveTab(key)}
//               className="custom-tabs w-full"
//               centered={true}
//             >
//               <TabPane tab="Cart" key="cart" />
//               <TabPane tab="Saved Products" key="saved" />
//             </Tabs>
//           </div> */
// }
// {
//   /* {products?.map((product) => {
//                               const qty = Number(product?.quantity ?? 0);
//                               const availableQty = Number(
//                                 product?.available_quantity ?? 0,
//                               );
//                               const isDisabled = qty >= availableQty;
//                               return (
//                                 <div
//                                   key={product.product_code}
//                                   className="mb-6 px-4"
//                                 >
//                                   <div className="flex justify-between items-center">
//                                     <div>
//                                       <Text
//                                         className="block mb-1 text-[#222]"
//                                         style={{
//                                           fontSize: 14,
//                                           fontWeight: "500",
//                                         }}
//                                       >
//                                         {product?.product_name}
//                                       </Text>
//                                     </div>
//                                     <div>
//                                       <Tooltip title={"Move to Cart"}>
//                                         <Button
//                                           type="text"
//                                           icon={
//                                             <UndoOutlined className="text-gray-500" />
//                                           }
//                                           size="small"
//                                           onClick={() =>
//                                             movetoCart(product.product_code)
//                                           }
//                                         />
//                                       </Tooltip>
//                                       <Tooltip
//                                         title={"Remove from Save Products"}
//                                       >
//                                         <Button
//                                           type="text"
//                                           icon={
//                                             <DeleteOutlined className="text-red-600" />
//                                           }
//                                           size="small"
//                                           onClick={() =>
//                                             handleRemoveFromFavourite(
//                                               product.product_code,
//                                             )
//                                           }
//                                         />
//                                       </Tooltip>
//                                     </div>
//                                   </div>
//                                   <div className="flex items-center justify-between">
//                                     <div className="flex items-center border border-[#d0d7e2] rounded-[6px] overflow-hidden bg-white">
//                                       <div className="w-[44px] h-[32px] flex items-center justify-center border-r border-[#d0d7e2] text-[#4a4a4a] text-sm">
//                                         {product?.quantity}
//                                       </div>
//                                     </div>

//                                     <div className="flex items-center gap-3">
//                                       <Text strong>
//                                         ${" "}
//                                         {Number(
//                                           product?.unit_price *
//                                             product?.quantity,
//                                         ).toLocaleString(undefined, {
//                                           minimumFractionDigits: 2,
//                                           maximumFractionDigits: 2,
//                                         })}
//                                       </Text>
//                                     </div>
//                                   </div>
//                                 </div>
//                               );
//                             })} */
// }

//  {/* <div
//                 className="scrollbar-hide flex-1 w-full md:w-[60%]"
//                 // style={{ maxWidth: "100%" }}
//               >
//                 <Table
//                   dataSource={dataSource}
//                   loading={tblLoading}
//                   columns={tblColumns}
//                   className="border-table custom-table user-tbl scrollbar-hide"
//                   pagination={false}
//                   bordered
//                   scroll={{ x: "max-content", y: "400px" }}
//                   style={{ minWidth: "600px" }}
//                 />
//               </div> */}